<template>
  <MapGeoJSONLayer :geojson="geojson" :layers="layers" />
</template>
<script setup lang="ts">
import type { Feature, MultiLineString } from "geojson";
import type { LineLayer } from "mapbox-gl";

const props = defineProps<{
  checkpoints: { id: any; lat: any; lng: any; radius?: null | number }[];
  endIsStart?: boolean;
}>();

// return a point that is "fraction" moved from a towards b.
function moveTowards(
  a: [number, number],
  b: [number, number],
  fraction: number
): [number, number] {
  const vector = [(b[0] - a[0]) * fraction, (b[1] - a[1]) * fraction];

  return [a[0] + vector[0], a[1] + vector[1]];
}

const geojson = ref({
  type: "Feature",
  geometry: {
    type: "MultiLineString",
    coordinates: [],
  },
  properties: {},
} as Feature<MultiLineString>);

const metersToPixels = useMetersToPixels();

watch(
  [() => props.checkpoints, () => props.endIsStart],
  ([checkpoints, endIsStart]) => {
    const lines = [];
    for (let i = 0; i < checkpoints.length; i++) {
      const a = checkpoints[i];
      if (i === checkpoints.length - 1 && !endIsStart) continue;
      const b = checkpoints[i + 1] || checkpoints[0];

      const start = [Number(a.lng), Number(a.lat)] as [number, number];
      const end = [Number(b.lng), Number(b.lat)] as [number, number];

      const distance = geodistance(...start, ...end);

      if (distance < Number(a.radius) + Number(b.radius)) {
        continue;
      }

      const metersPerPixel = 1 / metersToPixels(1, start[1]);

      const buffer = 10 * metersPerPixel;

      lines.push([
        moveTowards(start, end, (Number(a.radius) + buffer) / distance),
        moveTowards(end, start, (Number(b.radius) + buffer) / distance),
      ]);
    }
    geojson.value.geometry.coordinates = lines;
  },
  { deep: true, immediate: true }
);

const layers = [
  {
    type: "line",
    paint: {
      "line-width": 2,
      "line-color": "red",
    },
  },
] as LineLayer[];
</script>
